import { locations } from "../../common/redux/action_locations";
import {
    FETCH_MU,
    FETCH_AGENT,
    FETCH_TEAM,
    MU_RECEIVED_DATA,
    AGENT_RECEIVED_DATA,
    TEAM_RECEIVED_DATA
} from "./constants";
import { CFAuthGetRef } from "auth";

export function fetchMUAction(filters) {    
    return {
        type: FETCH_MU,
        fetchCall: fetchMU,
        receivedAction: receivedMU,
        data: {
            filters,
            locations
        }
    };
}

function fetchMU(filters) {
    return CFAuthGetRef({
        url: process.env.REACT_APP_DATA_PROXY_API_URL + "/CCMProxy/GetSecuredManagementUnitDictionary",
        params: {},
        originURL: process.env.PUBLIC_URL,
        loaderName: "fetchMU"
    });
}

function receivedMU(data) {
    let uiModelData = [];
    let muIds = [];

    if(data) {
        Object.keys(data).forEach(function(index) {
            uiModelData.push({
                key: index,
                name: data[index]
            });

            muIds.push(index);
        });
    }

    return {
		type: MU_RECEIVED_DATA,
        muData: uiModelData,
        muIds: muIds
	};
}

export function fetchAgentAction(filters) {
    return {
        type: FETCH_AGENT,
        fetchCall: fetchAgent,
        receivedAction: receivedAgent,
        data: {
            filters,
            locations
        }
    };
}

function fetchAgent(filters) {
    return CFAuthGetRef({
        url: process.env.REACT_APP_DATA_PROXY_API_URL + "/CCMProxy/GetSecuredAgentDictionary",
        params: {},
        originURL: process.env.PUBLIC_URL,
        loaderName: "fetchAgent"
    });
}

function receivedAgent(data) {
    let uiModelData = [];
    
    if(data) {
        Object.keys(data).forEach(function(index) {
            uiModelData.push({
                key: index,
                name: data[index].Name,
                parentName: data[index].ParentName
            });
        });
    }

    return {
		type: AGENT_RECEIVED_DATA,
		agentData: uiModelData
	};
}

export function fetchTeamAction(filters) {
    return {
        type: FETCH_TEAM,
        fetchCall: fetchTeam,
        receivedAction: receivedTeam,
        data: {
            filters,
            locations
        }
    };
}

function fetchTeam(filters) {
    return CFAuthGetRef({
        url: process.env.REACT_APP_DATA_PROXY_API_URL + "/CCMProxy/GetSecuredTeamDictionary",
        params: {},
        originURL: process.env.PUBLIC_URL,
        loaderName: "fetchTeam"
    });
}

function receivedTeam(data) {
    let uiModelData = [];
    
    if(data) {
        Object.keys(data).forEach(function(index) {
            uiModelData.push({
                key: index,
                name: data[index].Name,
                parentName: data[index].ParentName
            });
        });
    }

    return {
		type: TEAM_RECEIVED_DATA,
		teamData: uiModelData
	};
}

export function viewPerformanceMetricsDetailedView() {
    let viewScorecard = true;
    window.scrollTo(0, 0);
    return {
        type: "VIEW_PERFORMANCE_METRICS_SCORECARD",
        viewScorecard: viewScorecard
    };
}

export function closePerformanceMetricsDetailedView() {
    let viewScorecard = false;
    return {
        type: "VIEW_PERFORMANCE_METRICS_SCORECARD",
        viewScorecard: viewScorecard
    };
}

export function notifyFilterOfSelections(items) {
    return {
        type: "NotifyFilterOfSelections",
        items: items
    };
}

export function reducer(state, action) {
    switch (action.type) {
        case MU_RECEIVED_DATA:
            return {
                ...state,
                muData: action.muData,
                muIds: action.muIds
            };
        case AGENT_RECEIVED_DATA:
            return {
                ...state,
                agentData: action.agentData
            };
        case TEAM_RECEIVED_DATA:
            return {
                ...state,
                teamData: action.teamData
            };
        case "VIEW_PERFORMANCE_METRICS_SCORECARD":
            return {
                ...state,
                viewScorecard: action.viewScorecard
        };
        case "NotifyFilterOfSelections":
            return {
                ...state,
                items: action.items
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/features/scorecard/redux/performance_metrics_data_actions.js